import { Spinner } from '@/shared/components/ui'
import { cn } from '@/shared/lib/utils'

export function PageLoader() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-canvas"
      role="status"
      aria-label="Loading"
    >
      <Spinner className="h-8 w-8 text-brand-500" />
    </div>
  )
}

export function ContentLoader() {
  return (
    <div className="flex items-center justify-center py-12" role="status" aria-label="Loading content">
      <Spinner className="h-6 w-6 text-brand-500" />
    </div>
  )
}

export function SkeletonBlock({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse rounded-lg bg-neutral-200', className ?? 'h-4 w-full')}
      aria-hidden="true"
    />
  )
}

export function CardSkeleton() {
  return (
    <div className="space-y-3 rounded-2xl border border-line bg-white p-4 shadow-card">
      <SkeletonBlock className="h-4 w-1/3" />
      <SkeletonBlock className="h-6 w-1/2" />
      <SkeletonBlock className="h-4 w-2/3" />
    </div>
  )
}
